// extracted by mini-css-extract-plugin
module.exports = {"Intro":"ConnectSuppliersPage_Intro__1mWeh"};